import { computed, ref } from "vue";
import { type Router } from "vue-router";

import config from "@/common/config";
import { sleep } from "@/common/utils";

const loadingAnimationDuration = config.debug ? 0 : 1700;

const showLoader = ref<boolean>(false);

export function useLoader(router: Router) {
  const showLoading = computed<boolean>(() => {
    if (config.debug) {
      return false;
    }

    return !showLoader.value && !router.currentRoute.value.meta.disableLoader;
  });

  const showLoadingWhile = async (tasks: Promise<unknown>[]) => {
    showLoader.value = false;
    await Promise.all([...tasks, sleep(loadingAnimationDuration)]);
    showLoader.value = true;
  };

  return {
    showLoadingWhile,
    showLoading
  };
}
